import React, { Suspense } from 'react';
import { isReactSnap } from '../bootstrap/bootRuntime';

const CookieConsent = React.lazy(() => import('./CookieConsent'));

export const COOKIE_CONSENT_IDLE_TIMEOUT_MS = 1500;

const DeferredCookieConsent = () => {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined' || isReactSnap()) {
      return undefined;
    }

    let idleHandle = null;
    let timeoutHandle = null;

    const loadCookieConsent = () => {
      setShouldRender(true);
    };

    if (typeof window.requestIdleCallback === 'function') {
      idleHandle = window.requestIdleCallback(loadCookieConsent, { timeout: COOKIE_CONSENT_IDLE_TIMEOUT_MS });
    } else {
      timeoutHandle = window.setTimeout(loadCookieConsent, 0);
    }

    return () => {
      if (typeof window.cancelIdleCallback === 'function' && idleHandle !== null) {
        window.cancelIdleCallback(idleHandle);
      }

      if (timeoutHandle !== null) {
        window.clearTimeout(timeoutHandle);
      }
    };
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <CookieConsent />
    </Suspense>
  );
};

export default DeferredCookieConsent;
